
import React, { useState, useEffect, useRef } from 'react';
import { Link } from 'react-router-dom';
import { useLocation } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSearch, faChevronDown } from '@fortawesome/free-solid-svg-icons';
import './searchresults.css';
import locationIcon from '../../../assets/images/Ic_location.png';
import experienceIcon from '../../../assets/images/Ic_work.png';
import gridIcon from '../../../assets/images/Ic_coloum.png';
import linesIcon from '../../../assets/images/Ic_list.png';
import personIcon from '../../../assets/images/Icons profile.png';
import positionIcon from '../../../assets/images/Ic_work position.png';
import industryIcon from '../../../assets/images/Ic_work company.png';
import locIcon from '../../../assets/images/Ic_location1.png';
import salaryIcon from '../../../assets/images/Ic_amount.png';
import Pricing from '../pricingsection/pricingsection';

const allResults = [
  {
    experience: '30',
    position: 'Plant Manager',
    industry: 'Pharmacy',
    location: 'Bangalore',
    salary: '35L/annum',
  },
  {
    experience: '20',
    position: 'CEO',
    industry: 'Chemical',
    location: 'Bangalore',
    salary: '35L/annum',
  },
  {
    experience: '20',
    position: 'CEO',
    industry: 'Textile',
    location: 'Bangalore',
    salary: '35L/annum',
  },
  {
    experience: '20',
    position: 'Plant Manager',
    industry: 'Chemical',
    location: 'Mumbai',
    salary: '35L/annum',
  },
  {
    experience: '17',
    position: 'Plant Manager',
    industry: 'Pharmacy',
    location: 'Bangalore',
    salary: '25L/annum',
  },
  {
    experience: '20',
    position: 'Plant Manager',
    industry: 'Textile',
    location: 'Pune',
    salary: '40L/annum',
  },
  {
    experience: '18',
    position: 'Plant Manager',
    industry: 'Design',
    location: 'Bangalore',
    salary: '25L/annum',
  },
  {
    experience: '17',
    position: 'Plant Manager',
    industry: 'Pharmacy',
    location: 'Chennai',
    salary: '26L/annum',
  },
];
const experienceRanges = {
  '15-20 Yrs': [15, 20],
  '20-25 Yrs': [20, 25],
  '30+ Yrs': [30, Infinity],
};
const allExperienceOptions = Object.keys(experienceRanges);

const SearchResults = () => {
  const [searchPosition, setSearchPosition] = useState('');
  const [selectedLocations, setSelectedLocations] = useState([]);
  const [selectedYears, setSelectedYears] = useState([]);
  const [showLocationDropdown, setShowLocationDropdown] = useState(false);
  const [showYearDropdown, setShowYearDropdown] = useState(false);
  const [showFilter, setShowFilter] = useState(false);
  const [showSortBy, setShowSortBy] = useState(false);
  const [selectedSalary, setSelectedSalary] = useState(null);
  const [selectedIndustries, setSelectedIndustries] = useState([]);
  const [sortOption, setSortOption] = useState('most-relevant');
  const [viewMode, setViewMode] = useState('grid');
  const [searchTerm, setSearchTerm] = useState('');
  const [recentSearches, setRecentSearches] = useState([]);
  const [isSearchFocused, setIsSearchFocused] = useState(false);
  const searchInputRef = useRef(null);
  const recentSearchesRef = useRef(null);
  const location = useLocation();
  const [filteredResults, setFilteredResults] = useState([]);
  const [selectedCity, setSelectedCity] = useState('');
  const [selectedExperience, setSelectedExperience] = useState('');
  const [isMediumScreen, setIsMediumScreen] = useState(false);

  useEffect(() => {
    if (location.state) {
      const { results, selectedCity, selectedExperience } = location.state;
      setFilteredResults(results);
      setSelectedLocations(selectedCity ? [selectedCity] : []);
      setSelectedYears(selectedExperience ? [selectedExperience] : []);
    }
  }, [location.state]);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        recentSearchesRef.current &&
        !recentSearchesRef.current.contains(event.target) &&
        searchInputRef.current &&
        !searchInputRef.current.contains(event.target)
      ) {
        setIsSearchFocused(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  const handlePositionInputChange = (event) => {
    setSearchPosition(event.target.value);
  };

  const handleLocationChange = (event) => {
    const value = event.target.value;
    if (value === 'All Location') {
      if (selectedLocations.includes('All Location')) {
        setSelectedLocations([]);
      } else {
        setSelectedLocations(['All Location']);
      }
    } else {
      setSelectedLocations((prev) => (prev.includes(value) ? prev.filter((loc) => loc !== value) : [...prev, value]));
    }
  };

  const handleRemoveLocation = (location) => {
    setSelectedLocations((prev) => prev.filter((loc) => loc !== location));
  };

  const isLocationSelected = (location) => {
    return selectedLocations.includes('All Location') || selectedLocations.includes(location);
  };

  const handleYearChange = (event) => {
    const value = event.target.value;

    if (value === 'All Experience') {
      if (selectedYears.includes('All Experience')) {
        setSelectedYears([]);
      } else {
        setSelectedYears(['All Experience']);
      }
    } else {
      setSelectedYears((prev) => {
        const newSelectedYears = prev.includes(value)
          ? prev.filter((year) => year !== value)
          : [...prev.filter((year) => year !== 'All Experience'), value];

        if (newSelectedYears.length === allExperienceOptions.length) {
          return ['All Experience'];
        }

        return newSelectedYears;
      });
    }
  };

  const handleRemoveYear = (year) => {
    setSelectedYears((prev) => prev.filter((yr) => yr !== year));
  };

  const isExperienceInRange = (experience) => {
    if (selectedYears.length === 0 || selectedYears.includes('All Experience')) return true;
    return selectedYears.some((yearRange) => {
      const [min, max] = experienceRanges[yearRange];
      return experience >= min && experience <= max;
    });
  };

  const handleSearchClick = () => {
    if (searchPosition && !recentSearches.includes(searchPosition)) {
      setRecentSearches((prev) => [...new Set([searchPosition, ...prev])]);
    }
    const results = allResults.filter((result) => {
      return (
        result.position.toLowerCase().includes(searchPosition.toLowerCase()) &&
        (selectedLocations.length === 0 || isLocationSelected(result.location)) &&
        isExperienceInRange(result.experience)
      );
    });
    setFilteredResults(results);
    setShowResults(true);
  };

  const handleRecentSearchSelect = (search) => {
    setSearchPosition(search);
    setIsSearchFocused(false);
    handleSearchClick();
  };

  const removeRecentSearch = (search) => {
    setRecentSearches((prev) => prev.filter((item) => item !== search));
  };

  const isSalaryInRange = (salary) => {
    if (selectedSalary === null) return true;
    switch (selectedSalary) {
      case '10L-15L':
        return (
          salary.includes('10L') ||
          salary.includes('11L') ||
          salary.includes('12L') ||
          salary.includes('13L') ||
          salary.includes('14L') ||
          salary.includes('15L')
        );
      case '15L-25L':
        return (
          salary.includes('15L') ||
          salary.includes('16L') ||
          salary.includes('17L') ||
          salary.includes('18L') ||
          salary.includes('19L') ||
          salary.includes('20L') ||
          salary.includes('21L') ||
          salary.includes('22L') ||
          salary.includes('23L') ||
          salary.includes('24L') ||
          salary.includes('25L')
        );
      case '25+L':
        return (
          salary.includes('25L') ||
          salary.includes('26L') ||
          salary.includes('27L') ||
          salary.includes('28L') ||
          salary.includes('29L') ||
          salary.includes('30L') ||
          salary.includes('31L') ||
          salary.includes('32L') ||
          salary.includes('33L') ||
          salary.includes('34L') ||
          salary.includes('35L') ||
          salary.includes('36L') ||
          salary.includes('37L') ||
          salary.includes('38L') ||
          salary.includes('39L') ||
          salary.includes('40L') ||
          salary.includes('41L') ||
          salary.includes('42L') ||
          salary.includes('43L') ||
          salary.includes('44L') ||
          salary.includes('45L')
        );
      default:
        return false;
    }
  };

  const handleSalaryClick = (salary) => {
    setSelectedSalary(salary);
  };

  const handleCheckboxChange = (event) => {
    const value = event.target.value;
    setSelectedIndustries((prev) =>
      prev.includes(value) ? prev.filter((industry) => industry !== value) : [...prev, value]
    );
  };

  const handleRemoveIndustry = (industry) => {
    setSelectedIndustries((prev) => prev.filter((ind) => ind !== industry));
  };

  const toggleFilter = () => {
    setShowFilter((prev) => !prev);
  };

  const toggleSortBy = () => {
    setShowSortBy(!showSortBy);
  };

  const handleSortChange = (e) => {
    setSortOption(e.target.value);
    setShowSortBy(false);
  };

  const handleApply = () => {
    const results = allResults.filter((result) => {
      return (
        result.position.toLowerCase().includes(searchPosition.toLowerCase()) &&
        (selectedLocations.length === 0 || isLocationSelected(result.location)) &&
        isExperienceInRange(result.experience) &&
        isSalaryInRange(result.salary) &&
        (selectedIndustries.length === 0 || selectedIndustries.includes(result.industry))
      );
    });
    setFilteredResults(results);
    setShowFilter(false);
  };
  const handleReset = () => {
    setSelectedIndustries([]);
    setSelectedSalary(null);
  };

  const handleClose = () => {
    setShowFilter(false);
  };

  const handleViewToggle = (mode) => {
    setViewMode(mode);
  };

  const handleLocationClick = () => {
    setShowLocationDropdown((prev) => !prev);
  };

  const handleYearClick = () => {
    setShowYearDropdown((prev) => !prev);
  };

  useEffect(() => {
    const checkScreenSize = () => {
      const width = window.innerWidth;
      setIsMediumScreen(width >= 768 && width <= 1200);
    };

    checkScreenSize();
    window.addEventListener("resize", checkScreenSize);

    return () => {
      window.removeEventListener("resize", checkScreenSize);
    };
  }, []);

  const inlineRowStyleSearch = isMediumScreen
    ? {
      display: "grid",
      gridTemplateColumns: "repeat(2, 1fr)",
      justifyContent: "center",
      margin: "0",
    }
    : undefined;



  return (
    <div className="fluid-container">
      <div className="top-container d-flex flex-column py-3">
        <div className="page-content-wrapper">
          <div className="breadcrumb d-flex">
            <Link to="/" style={{ color: '#99A4AF', textDecoration: 'none', marginRight: '10px' }}>
              Home
            </Link>
            /
            <span style={{ marginLeft: '10px' }}>Search</span>
          </div>
        </div>
        <div className="subline-container">
          <h6 className="subline">Explore high-value candidates tailor-made for you</h6>
        </div>
      </div>


      <div className="search-wrapper">
        <div className="search-container">
          <div className="search-input">
            <FontAwesomeIcon icon={faSearch} className="searchbar-icon" />
            <input
              type="text"
              placeholder="Search"
              value={searchPosition}
              ref={searchInputRef}
              onClick={() => setIsSearchFocused(true)}
              onChange={handlePositionInputChange}
              onFocus={() => setIsSearchFocused(true)}
            // onBlur={(e) => {
            //   if (!recentSearchesRef.current.contains(e.relatedTarget)) {
            //     setIsSearchFocused(false);
            //   }
            // }}
            />
          </div>
          {/* {isSearchFocused && recentSearches.length > 0 && (
            <div ref={recentSearchesRef} className="recent-searches-dropdown">
              <p className="recent-search">Recent Search</p>
              {recentSearches.map((search, index) => (
                <div
                  key={index}
                  className="recent-search-item"
                  onMouseDown={(e) => e.preventDefault()}
                  onClick={() => handleRecentSearchSelect(search)}
                >
                  <span>{search}</span>
                  <button type="button" onClick={() => removeRecentSearch(search)}>
                    x
                  </button>
                </div>
              ))}
            </div>
          )}*/}{' '}
          <span className="search-divider"></span>
          <div className="location-select" onClick={handleLocationClick}>
            <div className="selected-locations">

              <img src={locationIcon} alt="Location Icon" className="location-icon" />
              {selectedLocations.length === 0 ? (
                <span className="default-location">Location<FontAwesomeIcon icon={faChevronDown} className="dropdown-icon-location" /></span>
              ) : (
                selectedLocations.map((location) => (
                  <span key={location} className="selected-location">
                    {location}
                    <button type="button" onClick={() => handleRemoveLocation(location)}>
                      x
                    </button>
                  </span>
                ))
              )}
            </div>
            <span className="selected-city">{selectedCity}</span>

            {showLocationDropdown && (
              <div className="location-dropdown">
                {['All Location', 'Bangalore', 'Chennai', 'Mumbai', 'Pune', 'Kolkata'].map((location) => (
                  <label key={location} className="location-option">
                    <input
                      type="checkbox"
                      value={location} style={{ marginRight: '10px' }}
                      Update via Whatsapp
                      onChange={handleLocationChange}
                      checked={selectedLocations.includes(location)}
                    />
                    {location}
                  </label>
                ))}
              </div>
            )}
          </div>
          <span className="search-divider"></span>
          <div className="year-select" onClick={handleYearClick}>
            <div className="selected-years">
              <img src={experienceIcon} alt="Experience Icon" className="experience-icon" />
              {selectedYears.length === 0 ? (
                <span className="default-year">Experience<FontAwesomeIcon icon={faChevronDown} className="dropdown-icon-experience" /></span>
              ) : (
                selectedYears.map((year) => (
                  <span key={year} className="selected-year">
                    {year}
                    <button type="button" onClick={() => handleRemoveYear(year)}>
                      x
                    </button>
                  </span>
                ))
              )}
            </div>
            <span className="selected-experience">{selectedExperience}</span>

            {showYearDropdown && (
              <div className="year-dropdown">
                {['All Experience', '15-20 Yrs', '20-25 Yrs', '30+ Yrs'].map((year) => (
                  <label key={year} className="year-option">
                    <input
                      type="checkbox"
                      value={year} style={{ marginRight: '10px' }}
                      Update via Whatsapp
                      onChange={handleYearChange}
                      checked={selectedYears.includes(year)}
                    />
                    {year}
                  </label>
                ))}
              </div>
            )}
          </div>
          <button className="searchbar-button" onClick={handleSearchClick}>
            Search
          </button>
        </div>
      </div>
      <div>
        <div className="results-controls" >
          <div className="results-count">Search Result <span className="result-count-number">({filteredResults.length})</span></div>
          <div className="filter-sort-container">
            <div className="filter-by-container" >
              <button className="filter-button" onClick={toggleFilter}>
                <span style={{ color: '#516F90', fontWeight: '600' }}>Filter by:</span>{' '}
                {selectedSalary !== null ? selectedSalary : 'None'}<FontAwesomeIcon icon={faChevronDown} className="dropdown-icon-filter" />
              </button>
              {showFilter && (
                <div className="custom-filter">
                  <h3 className="filter-title">Filter By</h3>
                  <h3 className="salary-title">Salary</h3>
                  <div className="salary-options">
                    <div
                      className={`salary-option ${selectedSalary === null ? 'selected' : ''}`}
                      onClick={() => handleSalaryClick(null)}
                    >
                      None
                    </div>
                    <div
                      className={`salary-option ${selectedSalary === '10L-15L' ? 'selected' : ''}`}
                      onClick={() => handleSalaryClick('10L-15L')}
                    >
                      10L-15L
                    </div>
                    <div
                      className={`salary-option ${selectedSalary === '15L-25L' ? 'selected' : ''}`}
                      onClick={() => handleSalaryClick('15L-25L')}
                    >
                      15L-25L
                    </div>
                    <div
                      className={`salary-option ${selectedSalary === '25+L' ? 'selected' : ''}`}
                      onClick={() => handleSalaryClick('25+L')}
                    >
                      25+L
                    </div>
                  </div>
                  <h3 className="industry-title">Industry</h3>
                  <div className="industry-search-wrapper">
                    <div className="input-wrapper">
                      {selectedIndustries.map((industry) => (
                        <span key={industry} className="selected-industry">
                          {industry}
                          <button type="button" onClick={() => handleRemoveIndustry(industry)} className="remove-btn">
                            x
                          </button>
                        </span>
                      ))}
                      <input
                        type="text"
                        className="industry-search"
                        placeholder="Search Industry"
                        value={searchTerm}
                        onChange={(e) => setSearchTerm(e.target.value)}
                      />
                      <button type="button" className="close-btn" onClick={handleClose}>
                        x
                      </button>
                    </div>
                  </div>
                  <ul className="industry-list list-unstyled">
                    {['Automotive', 'Design', 'Development', 'Devops']
                      .filter((industry) => industry.toLowerCase().includes(searchTerm.toLowerCase()))
                      .map((industry) => (
                        <li key={industry} className="industry-option">
                          <label className="d-block">
                            <input
                              type="checkbox"
                              value={industry}
                              onChange={handleCheckboxChange}
                              checked={selectedIndustries.includes(industry)}
                              className="me-2"
                            />
                            {industry}
                          </label>
                        </li>
                      ))}
                  </ul>
                  <div className="filter-buttons">
                    <button className="reset-button" onClick={handleReset}>
                      Reset
                    </button>
                    <button className="apply-button" onClick={handleApply}>
                      Apply
                    </button>
                  </div>
                </div>
              )}
            </div>

            <div className="sort-by-container">
              <button className="sort-by-button" onClick={toggleSortBy}>
                <span style={{ color: '#516F90', fontWeight: '600' }}>Sort by:</span> {sortOption.replace('-', ' ')}
                <FontAwesomeIcon icon={faChevronDown} className="dropdown-icon-sort" />
              </button>
              {showSortBy && (
                <div className="sort-by-options">
                  <h3 className="filter-title">Sort by</h3>
                  <label className="radio-container">
                    <input
                      type="radio"
                      value="most-relevant"
                      checked={sortOption === 'most-relevant'}
                      onChange={handleSortChange}
                    />
                    <span className="custom-radio"></span>
                    Most Relevant
                  </label>
                  <label className="radio-container">
                    <input type="radio" value="latest" checked={sortOption === 'latest'} onChange={handleSortChange} />
                    <span className="custom-radio"></span>
                    Latest
                  </label>
                  <label className="radio-container">
                    <input type="radio" value="popular" checked={sortOption === 'popular'} onChange={handleSortChange} />
                    <span className="custom-radio"></span>
                    Popular
                  </label>
                </div>
              )}
            </div>

            <div className="view-toggle-container">
              <div className="view-toggle-icons">
                <div
                  className={`icon-container ${viewMode === 'grid' ? 'active' : ''}`}
                  onClick={() => handleViewToggle('grid')}
                >
                  <img src={gridIcon} alt="Grid Icon" className={`icon ${viewMode === 'grid' ? 'active-icon' : ''}`} />
                </div>
                <div
                  className={`icon-container ${viewMode === 'list' ? 'active' : ''}`}
                  onClick={() => handleViewToggle('list')}
                >
                  <img src={linesIcon} alt="Lines Icon" className={`icon ${viewMode === 'list' ? 'active-icon' : ''}`} />
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="searchresults-card-container mt-4" >
          <div
            className={`row ${viewMode === 'grid' ? (
              `row-cols-1 row-cols-md-2 ${filteredResults.length === 2 ? 'row-cols-lg-2' : 'row-cols-lg-3'}`
            ) : ''}`}
            style={inlineRowStyleSearch}
          >
            {filteredResults.map((card, index) => (
              <div className="col mb-4" key={index}>
                <div className={`result-card ${viewMode === 'grid' ? 'grid-card' : 'list-card'}`}>
                  <div className="searchresults-card-header d-flex justify-content-between align-items-start">
                    <div className="d-flex align-items-center" >
                      <img src={personIcon} alt="Person Icon" className="person-icon" />
                      <div className="card-header-text">
                        <h5>XXXXX XXXXXX</h5>
                        <p>Experience: {card.experience} Years</p>
                      </div>
                    </div>
                    {viewMode === 'list' && (
                      <>
                        <hr className="card-divider" />
                        <div className="card-skills">
                          <p className="skill-item">Financial Reporting</p>
                          <span className="skill-divider"></span>
                          <p className="skill-item">Plant Accounting</p>
                          <span className="skill-divider"></span>
                          <p className="skill-item">Manpower Handling</p>
                          <span className="skill-divider"></span>
                          <p className="skill-item">Maintainance</p>
                        </div>
                      </>
                    )}
                  </div>
                  <div className="card-content mt-3">
                    <div className="info-item">
                      <img src={positionIcon} alt="Position Icon" className="info-icon" />
                      <p className="info-item-p">{card.position}</p>
                    </div>
                    <div className="info-item">
                      <img src={industryIcon} alt="Industry Icon" className="info-icon" />
                      <p className="info-item-p">{card.industry}</p>
                    </div>
                    <div className="info-item">
                      <img src={locIcon} alt="Location Icon" className="info-icon" />
                      <p className="info-item-p">{card.location}</p>
                    </div>
                    <div className="info-item">
                      <img src={salaryIcon} alt="Salary Icon" className="info-icon" />
                      <p className="info-item-p">{card.salary}</p>
                    </div>
                  </div>
                  {viewMode === 'grid' && (
                    <>
                      <hr className="card-divider" />
                      <div className="card-skills">
                        <p className="skill-item">Financial Reporting</p>
                        <span className="skill-divider"></span>
                        <p className="skill-item">Plant Accounting</p>
                      </div>
                      <div className="card-skills">
                        <p className="skill-item">Manpower Handling</p>
                        <span className="skill-divider"></span>
                        <p className="skill-item">Maintainance</p>
                      </div>
                    </>
                  )}
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
      <Pricing page="searchresults" className="white-background" hideTopSections={true} />
    </div>
  );
};

export default SearchResults;